// extracted by mini-css-extract-plugin
export default {"columnList":"TwoColumnList_columnList__32zn1","column":"TwoColumnList_column__a3iIM","item":"TwoColumnList_item__z3wux"};